import { X, Download, Loader2 } from "lucide-react";

interface InvoicePdfPreviewModalProps {
  open: boolean;
  loading: boolean;
  pdfUrl: string | null;
  filename?: string;
  onClose: () => void;
}

export default function InvoicePdfPreviewModal({
  open,
  loading,
  pdfUrl,
  filename = "invoice.pdf",
  onClose,
}: InvoicePdfPreviewModalProps) {
  if (!open) return null;

  const handleDownload = () => {
    if (!pdfUrl) return;

    const a = document.createElement("a");
    a.href = pdfUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="relative flex h-[90vh] w-full max-w-3xl flex-col rounded-2xl bg-white shadow-xl">
        <button
          onClick={onClose}
          className="absolute -right-3 -top-3 flex h-8 w-8 items-center justify-center rounded-full bg-red-500 text-white shadow-md hover:bg-red-600"
          aria-label="Close preview"
        >
          <X size={18} />
        </button>

        <div className="flex-1 overflow-hidden rounded-t-2xl bg-gray-100 p-4">
          {loading && (
            <div className="flex h-full items-center justify-center gap-2 text-gray-500">
              <Loader2 className="animate-spin" size={20} />
              <span>Loading preview...</span>
            </div>
          )}

          {!loading && pdfUrl && (
            <iframe
              src={pdfUrl}
              title="Invoice Preview"
              className="h-full w-full rounded-lg border border-gray-200 bg-white"
            />
          )}

          {!loading && !pdfUrl && (
            <div className="flex h-full items-center justify-center text-gray-400">
              Failed to load preview.
            </div>
          )}
        </div>

        <div className="flex justify-center border-t border-gray-100 p-4">
          <button
            onClick={handleDownload}
            disabled={loading || !pdfUrl}
            className="flex items-center gap-2 rounded-xl bg-blue-600 px-5 py-2.5 font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            <Download size={18} />
            Download PDF
          </button>
        </div>
      </div>
    </div>
  );
}
